import { ReactNode } from 'react';
import Image from 'next/image';
import tw, { styled, TwStyle } from 'twin.macro';

import { getAssetSrc, customImageLoader } from '@restworld/utils-common';
import { Paragraph, Title } from '@restworld/ui-ds';

interface EmployerNoResultsProps {
  title: string;
  content: string;
  buttonEl?: ReactNode;
  contentStyle?: TwStyle;
}

function EmployerNoResults({ title, content, buttonEl, contentStyle }: EmployerNoResultsProps) {
  return (
    <Container>
      <Image
        src={getAssetSrc('/utils-assets/not-found.svg')}
        width={160}
        height={150}
        alt="non trovato"
        loader={customImageLoader}
      />
      <Title
        content={title}
        textColor="grey-900"
        fontWeight="medium"
        fontSize="large"
        twStyle={tw`text-lg text-center`}
      />
      <Paragraph font="medium" color="gray-600" twStyle={[tw`max-w-sm text-center`, contentStyle || tw``]}>
        {content}
      </Paragraph>
      {buttonEl}
    </Container>
  );
}
export default EmployerNoResults;

const Container = styled.div`
  ${tw`flex flex-col items-center gap-7`}
`;
